import React, { useEffect, useState } from 'react';
import { getAnnouncemetData } from '../service/api';
import { useNavigate, useLocation } from 'react-router-dom';
import { getS3 } from '../utils/Download.js';
import '../components/css/Announcement.css';

const AnnouncementBlog = () => {
    const { state } = useLocation();

    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [description, setDescription] = useState();
    const [secureURL, setSecureURL] = useState('');
    useEffect(() => {
        //
        fetchApi();
    }, []);
    function replaceURLs(message) {
        if (!message) return;

        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return message.replace(urlRegex, function (url) {
            var hyperlink = url;
            if (!hyperlink.match('^https?://')) {
                hyperlink = 'http://' + hyperlink;
            }
            return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
        });
    }

    const fetchApi = async () => {
        const id = state.id;

        const resp = await getAnnouncemetData(id);

        if (resp?.data?.ResponseData.length) {
            let description = resp?.data?.ResponseData[0]?.description;
          
            setData(resp?.data?.ResponseData[0]);

            replaceURLs(description);

            setDescription(replaceURLs(description));

            const imageURL = await getS3(resp?.data?.ResponseData[0]?.attachment, "1");
            setSecureURL(imageURL);
           
        }
        
    };

    return (
        <>
            <div className="container-fluid cover-pic">
                <div className="d-flex justify-content-center">
                    <div className="col-md-8 mt-5 bg-white rounded-3">
                        <div className="announcement-cover-pic rounded-3 position-relative mt-3">
                            <a
                                onClick={() => {
                                    navigate('/overview?tab=activities');
                                }}
                            >
                                <img src="/Images/Annoucement-back-button.svg" className="position-absolute annoucement-backbutton-posi" />
                            </a>
                        </div>
                        <div className="px-4 py-4">
                            {/* <p className="font-20 regular-text m-0">New Vibe</p> */}
                            <p className="font-28 annoucement-font">{data.title}</p>
                            <img src="/Images/BigQuotes.svg" alt="" />
                        </div>
                        <div className="ps-4 position-relative mb-5">
                            <div className="col-md-8 textcontent-style px-2 py-2">
                                <p className="regular-text font-14">
                                    {' '}
                                    <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                </p>
                            </div>
                            <div className="col-md-4">
                                <img src={secureURL} alt="Announcement-image" className="Announcement-image-size position-absolute" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AnnouncementBlog;
